



import React, { useState } from 'react';
import styled from 'styled-components';
// import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';





const Wrapper = styled.section`
/* z-index: 5; */
position: absolute;
top:0;
display:flex;
flex-direction:row;
justify-content: space-between;
align-items: center;
width: 100%;


.header{
    /* padding-bottom: 8%; */
    z-index: 3;
    background:#EC632F;
   height: 70px;
   position: absolute;
   top: 0px;
   display:flex;
flex-direction:row;
justify-content: space-between;
align-items: center;
width: 100%;   
}

img{
    width: 20%;
    margin-left: 10px;
}

/* .active{
    font-weight:bolder;
} */
ul{
   gap : 40px;
    z-index: 4;
    position: absolute;
   left : 0;
top: 0;  
width: 100%;
height: 100vh;
background: #4A5AF8;
max-height:0vh;
overflow: hidden;
display: flex;
flex-direction:column;
justify-content: center;
align-items: center;
transition:all 0.7s ease-in-out;
li:hover {
    background-color: blue;

  }

}
ul li {
position: relative;
    display: block;
    color:#F1F1FE;
    font-weight:bolder ;
    padding: 10px;
    width: max-content;
color :#fff;
} 


 a {
    text-decoration: none;
    color: #F1F1FE;
    font-size: 20px;
    font-weight: bolder;
    width: max-content;
}
.hamburger{
  right: 30px;
    padding:20px 37px 20px 6px;
      position: absolute;
      /* margin-right:0px; */
      /* transition:all 0.7s ease; */
      z-index:9;

}

span{
    border-radius:15px;
   right: 0;
    position: absolute;
    transition: all .6s ease-in-out;
    width: 40px;
    height: 3px;
    background:#F1F1FE;
    &:before{
        border-radius:15px;
       right: 0;
        width: 100%;
    height: 100%;
   background:#F1F1FE;
    position: absolute;
    top: -9px;
    transition: all .6s ease-in-out;
    content: "";
    }
    &:after{
        border-radius:15px;
      right: 0;
        width: 100%;
    height: 100%;
     background:#F1F1FE;
    position: absolute;
    top: 9px;
    transition: all .6s ease-in-out;
    content: "";
    }
}


.open{
    transition:all 300ms ease;
    span{
        background:transparent;
        &:before{
       transform: rotate(496deg);
   top: 0;
    }
    &:after{
        transform: rotate(-496deg);
        top: 0;
    }
    }
}
.change{
    top: 0;
max-height:95vh;

}

@media (min-width: 568px) {
  ul li {
position: relative;
    display: block;
    color:#F1F1FE;
    font-weight:bolder ;
    padding: 10px;
    width: max-content;
    /* transition: all .4s ease-in-out;  */
    &:before{
    position: absolute;
content: '';
width: 100%;
height: 2px;
background: red;
top: -30px;
color :#fff;

  }
} 
}

@media (min-width: 768px) {


  .hamburger{
  right: 40px;
    padding:20px 37px 20px 6px;
      position: absolute;
      /* margin-right:0px; */
      /* transition:all 0.7s ease; */
      z-index:9;

}

span{
    border-radius:15px;
   right: 0;
    position: absolute;
    transition: all .6s ease-in-out;
    width: 50px;
    height: 4px;
    background:#F1F1FE;
    &:before{
        border-radius:15px;
       right: 0;
        width: 100%;
    height: 100%;
   background:#F1F1FE;
    position: absolute;
    top: -12px;
    transition: all .6s ease-in-out;
    content: "";
    }
    &:after{
        border-radius:15px;
      right: 0;
        width: 100%;
    height: 100%;
     background:#F1F1FE;
    position: absolute;
    top: 12px;
    transition: all .6s ease-in-out;
    content: "";
    }
}
    .header{
        height: 110px;
    }
    ul{
        height: 90vh;
        transition:all 0.7s ease-in-out;
        li{
            font-size: 28px;
            color :#fff;

        }
        a{}
    }
  
   img {
    width: 15%;
}
}

@media (min-width: 992px) {
    .donate{
width: 95px;
height: 50px;
background: blue;
display: flex;
justify-content: center;
align-items: center;
border-radius: 5%;
color: white;
    }
    img{
      margin-left: 2px;
      margin-top: 6%;
        width: 20%;

    }
    .header{
        height: 131px;
        background:none;
        height: 97px;
    }
   
   
    span{
    &:before{
      
    top: -8px;
    transition: all .6s ease-in-out;
    content: "";
    }
    &:after{
     
    top: 8px;
    transition: all .6s ease-in-out;
    content: "";
    }
}
  
ul{
padding-top: 15px;
    gap : 10px;
    z-index: 8;
    position: relative;
   right : 30px;
top: 0;  
width: 100%;
height: 100vh;
background: none;
max-height:100vh;
overflow: hidden;
display: flex;
flex-direction:row;
transition: none;
justify-content: flex-end;
margin-right: 30px;
li {
font-size: 22px;
display: block;
font-weight:bolder ;
padding: 10px;
width: max-content;
color :#fff;


} 
}

/* a {
   
    font-weight: bolder;
    width: max-content;
} */
/* .active{
    font-size: 25px;
    font-weight:bolder;
} */

 ul li:before {
    position: absolute;
    content: '';
    width: 0;
    height: 0px;
    background: none;
    top: 0px;
}

a {
    text-decoration: none;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    
}
 
.hamburger{
 display: none;
}
}


@media (min-width: 1200px) {
    .donate{
width: 120px;
height: 47px;
background: blue;
display: flex;
justify-content: center;
align-items: center;
border-radius: 6%;
color: white;
    }
img{
    width: 15%;
    height: unset;

}
    .header{
      height: 60px;
}
    .hamburger{
}


a {  
  color: #EC632F;
font-size: 18px;
  font-weight: 500;
}



ul{
   
   gap : 12px;
   z-index: 8;
   position: relative;
  left : 5px;
top: 0;  
width: 100%;
height: 100vh;
background: none;
max-height:100vh;
overflow: hidden;
display: flex;
flex-direction:row;
margin-right:63px;
    justify-content: flex-end;
    li:hover {
    background-color: transparent;
    
  }

li {

display: block;
color:black;
font-weight:bolder ;
padding: 10px;
width: max-content;
transition:  none;
} 
}


}
`

function Kuda() {
    const [click, setClick] = useState(false);
  return (
    <Wrapper>
 <div className='header'>
 <img src="./photos/BackgroundEraser_20240103_194309076.png" alt="photo"/>

<div className={click ? "hamburger open" : "hamburger"} onClick={() => setClick(!click)}>
<span></span>
 </div>
 
<ul className={click ? 'change' : ''}>

<li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/about">About</Link>
        </li>
        <li>
          <Link to="/services">Services</Link>
        </li>
        <li>
          <Link to="/join-us">Join Us</Link>
        </li>
        <li>
          <Link to="/contact">Contact</Link>
        </li>








          {/* <li>
            <NavLink to="/">
              Home
            </NavLink>
          </li> */}
        {/*   <li>
            <NavLink to="/our-story" activeClassName="at">
              Our Story
            </NavLink>
          </li>
          <li>
            <NavLink to="/innovation-hub" activeClassName="at">
              Innovation Hub
            </NavLink>
          </li>
          <li>
            <NavLink to="/hire-us" activeClassName="at">
              Hire Us
            </NavLink>
          </li>
          <li>
            <NavLink to="/donate" className="donate" activeClassName="at">
              Donate
            </NavLink>
          </li> */}
        </ul>
      </div>
    </Wrapper>
  )
}

export default Kuda

